import React from 'react'

export const CompanyHeader: React.FC = () => (
  <div className="header">
    <img className="logo" src="/images/pan.svg" />
    <ul>
      <li>
        <b>Wetaca | Come bien todos los días</b>
      </li>
      <li>Calle de la Resina 34, 28021 Madrid</li>
      <li>Atención al Cliente + 34 648 617 854 | info@wetaca.com</li>
      <li>Alcasal Soluciones de Alimentación S.L CIF: B87052007</li>
    </ul>
  </div>
)
